export default "__VITE_PUBLIC_ASSET__899e31af__"